"use strict";

import "core-js/modules/es.array.reduce.js";
import { useIsInView } from '@autoguru/intersection-observer-utils';
import { Box } from '@autoguru/overdrive';
import SimpleNextPicture from '@autoguru/picture/Picture/SimpleNextPicture';
import clsx from 'clsx';
import { useRef } from 'react';
import * as styles from './CarouselAssets.css';
import { jsx as _jsx } from "react/jsx-runtime";
// Carousel iterations: to set the number of bells for the infinite carousel
const carouselIterations = Array.from({
  length: 2
});
export const CarouselAssets = ({
  assetList,
  className
}) => {
  const containerRef = useRef(null);
  const {
    isInView
  } = useIsInView({
    threshold: 0.1
  }, containerRef);
  const sumOfLogoWidths = assetList.reduce((sum, asset) => sum + asset.width, 0);
  const spaceBetweenLogos = assetList.length * 24;
  const totalWidth = sumOfLogoWidths + spaceBetweenLogos;

  // Dynamic animation speed calculation
  // The divisor '50' can be adjusted for speed control.
  const animationDuration = `${totalWidth / 50}s`;
  return /*#__PURE__*/_jsx(Box, {
    ref: containerRef,
    display: "flex",
    className: clsx(className, styles.sliderContainer),
    children: carouselIterations.map((_, iterationIndex) => /*#__PURE__*/_jsx(Box
    // biome-ignore lint/suspicious/noArrayIndexKey: migration quick fix. To be fixed when code is touched
    , {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      className: clsx(styles.sliderBell, {
        [styles.sliderAnimated]: isInView
      }),
      style: {
        maxWidth: `${totalWidth}px`,
        animationDuration
      },
      children: assetList.map(asset => /*#__PURE__*/_jsx(Box, {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginX: "3",
        children: /*#__PURE__*/_jsx(SimpleNextPicture, {
          alt: asset.altText,
          width: asset.width,
          src: asset.imgPath,
          priority: true,
          loading: iterationIndex === 0 ? 'eager' : 'lazy' // Load initially visible images eagerly
        })
      }, `${iterationIndex}-${asset.imgPath}`))
    }, iterationIndex))
  });
};